import { v4 as uuidv4 } from "uuid";
import Act from "../../../../../../../../../../../store/actions";

const addTable = (dispatch, tableData) => {
  dispatch({
    type: Act.SNA_SET_AI_TABLE_CURRENT_PAGE,
    payload: 1,
  });
  const findAdding = tableData.find((el) => el.adding);
  if (findAdding) return;
  dispatch({
    type: Act.SNA_SET_AI_TABLE_DATA,
    payload: [
      {
        id: uuidv4(),
        source: "",
        srcId: "",
        srcLabel: "",
        dstId: "",
        dstLabel: "",
        mainEvn: "",
        subEvn: "",
        relationship: "",
        adding: true,
      },
      ...tableData,
    ],
  });
};

const watchInput = (dispatch) => {
  dispatch({
    type: Act.SNA_SET_AI_IS_WATCHING_INPUT,
    payload: true,
  });
};

export { addTable, watchInput };
